import React from 'react';
import {
  ComposedChart, Line, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { formatNumber } from '../../utils/chartDataUtils';
import styles from '../../styles/Team.module.css';

const EngagementTrendChart = ({ data }) => {
  const chartData = data;

  if (!chartData || chartData.length === 0) {
    return (
      <div className={styles.chartPlaceholder}>
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>📊</div>
          <h3>No Engagement Data Available</h3>
          <p>Engagement trend data will appear here once you have activity in the selected time period.</p>
        </div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart data={chartData}>
        <defs>
          <linearGradient id="reachGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#6366f1" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#6366f1" stopOpacity={0.1}/>
          </linearGradient>
          <linearGradient id="engagementGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#10b981" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#10b981" stopOpacity={0.1}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" strokeOpacity={0.3} />
        <XAxis 
          dataKey="date" 
          stroke="#9ca3af"
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis 
          stroke="#9ca3af"
          fontSize={12}
          tickFormatter={(value) => formatNumber(value)}
          tickLine={false}
          axisLine={false}
        />
        <Tooltip 
          contentStyle={{
            backgroundColor: '#1f2937',
            border: '1px solid #374151',
            borderRadius: '12px',
            color: '#f9fafb',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(10px)'
          }}
          formatter={(value, name) => [formatNumber(value), name]}
          labelStyle={{ color: '#6366f1', fontWeight: 'bold' }}
        />
        <Legend 
          wrapperStyle={{
            paddingTop: '20px',
            color: '#f9fafb'
          }}
        />
        <Area 
          type="monotone" 
          dataKey="reach" 
          stackId="1" 
          stroke="#6366f1" 
          fill="url(#reachGradient)"
          strokeWidth={2}
          name="Reach"
        />
        <Line 
          type="monotone" 
          dataKey="engagement" 
          stroke="#10b981" 
          strokeWidth={3}
          dot={{ 
            fill: '#10b981', 
            strokeWidth: 2, 
            r: 5,
            stroke: '#ffffff',
            filter: 'drop-shadow(0 2px 4px rgba(16, 185, 129, 0.3))'
          }}
          activeDot={{ 
            r: 8, 
            stroke: '#ffffff', 
            strokeWidth: 2,
            fill: '#10b981',
            filter: 'drop-shadow(0 4px 8px rgba(16, 185, 129, 0.4))'
          }}
          name="Engagement"
        />
        <Bar 
          dataKey="posts" 
          fill="#f59e0b" 
          opacity={0.8}
          radius={[4, 4, 0, 0]}
          name="Posts"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default EngagementTrendChart; 